import React from "react";
import { Avatar as ChakraAvatar } from "@chakra-ui/react";
import { Tooltip } from "./tooltip";
export function Avatar({ name, ...props }) {
    return (React.createElement(Tooltip, { isDisabled: !name, message: name ?? "" },
        React.createElement(ChakraAvatar, { name: name, ...props })));
}
